import clsx from 'clsx';
import { ChevronDown, X } from 'lucide-react';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Link } from '@reach/router';
import bigScreenNavData from '../big-screen-nav/data';
import { PBSLink } from '../../../atoms/link';

function SmallScreenNav({
	isMobile,
	isMenuOpen,
	handleMouseEnter,
	toggleMenu,
}) {
	const [openDropdown, setOpenDropdown] = useState(null);
	const [activeButton, setActiveButton] = useState(null);
	const handleButtonClick = (buttonName) => {
		setActiveButton(buttonName);
		if (handleMouseEnter) handleMouseEnter();
	};

	const toggleDropdown = (categoryTitle) => {
		setOpenDropdown((prev) =>
			prev === categoryTitle ? null : categoryTitle
		);
	};
	return (
		<div>
			{isMobile && (
				<div
					className={clsx(
						'fixed top-0 left-0 h-full bg-brand-pale-400 shadow-lg z-50  transition-transform duration-300 ease-in-out menu-container',
						{
							'translate-x-0': isMenuOpen,
							'-translate-x-full': !isMenuOpen,
						}
					)}
					style={{ width: '250px' }}
				>
					<div className="p-4  z-50 ">
						<button
							type="button"
							onClick={toggleMenu}
							className="focus:outline-none"
							aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
						>
							{isMenuOpen ? (
								<>
									<h1 className="flex">
										<p>
											<X className="w-8 h-8" />
										</p>
										<p className=" text-center mt-1 text-lg">
											Close
										</p>
									</h1>
								</>
							) : null}
						</button>
						<img
							src="https://www.datocms-assets.com/64336/1684148941-glu.svg"
							alt="glu logo"
							className="h-auto w-auto glu2xl:w-auto glu2xl:h-auto gluxs:w-40 gluxs:h-28 glumd:h-28 glumd:w-28"
						/>
						<div className="flex flex-col gap-4 space-y-4 mt-5">
							{bigScreenNavData.map((category) => (
								<div
									key={category.title}
									className={`relative ${
										openDropdown === category.title
											? 'mb-1'
											: ''
									}`}
								>
									<PBSLink
										to={category.link || ''}
										variant="Unset"
										className={`flex gap-2 items-center no-underline hover:bg-grey-400/20 font-lexend-regular border-none !text-black bg-brand-pale-400 w-full glulgx:w-[90%]  rounded-none cursor-pointer pl-4 pt-0 pr-4 pb-0 -ml-4 ${
											activeButton === category.title
												? 'bg-grey-400/20'
												: ''
										}`}
										onClick={() => {
											handleButtonClick(category.title);

											if (category.subcategories) {
												toggleDropdown(category.title);
											}
										}}
									>
										<div
											className={`w-2 h-12 bg-brand-blue-400 ${
												activeButton === category.title
													? 'visible'
													: 'invisible group-hover:visible'
											}`}
										/>
										<img
											src={category.icon}
											alt={category.title}
											className="w-8 h-8 -mt-1"
										/>

										{category.title}

										{category.subcategories && (
											<ChevronDown
												className={`ml-auto transition-transform ${
													openDropdown ===
													category.title
														? 'rotate-180'
														: 'rotate-0'
												}`}
												size={16}
											/>
										)}
									</PBSLink>

									{category.subcategories &&
										openDropdown === category.title && (
											<div
												className="mt-2 ml-4 bg-brand-pale-400 w-[90%] z-10 overflow-hidden transition-all duration-300 max-h-96 opacity-100"
												style={{ marginTop: '0.25rem' }}
											>
												{category.subcategories.map(
													(sub) => (
														<Link
															key={sub.title}
															to={sub.link}
															className="flex items-center gap-2 px-4 py-2 hover:bg-grey-400/20"
														>
															<img
																src={sub.icon}
																alt={sub.title}
																className="w-6 h-6"
															/>

															{sub.title}
														</Link>
													)
												)}
											</div>
										)}
								</div>
							))}
						</div>
					</div>
				</div>
			)}
		</div>
	);
}

export default SmallScreenNav;

SmallScreenNav.propTypes = {
	isMobile: '',
	handleMouseEnter: '',
	isMenuOpen: '',
	toggleMenu: '',
};

SmallScreenNav.defaultProps = {
	isMobile: PropTypes.bool,
	handleMouseEnter: PropTypes.func,
	isMenuOpen: PropTypes.bool,
	toggleMenu: PropTypes.func,
};
